import { makeStyles, Snackbar, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { IFeedbackCampaign } from "./feedback.type";
import { FeedbackQuestion } from "./FeedbackQuestion";
import DataProvider from "../../provider";
import { useParams } from "react-router";
import moment from "moment";
import { Alert } from "@material-ui/lab";

interface IFeedbackContainer {}

export const FeedbackContainer: React.FC<IFeedbackContainer> = (
	props: IFeedbackContainer
) => {
	const [campaign, setCampaign] = useState<IFeedbackCampaign>();
	const [status, setStatus] = useState("INITIAL");
	const [answeredQuestion, setAnsweredQuestion] = useState<string[]>([]);
	const [snackbarShow, setSnackbarShow] = useState(false);

	const dataProvider = DataProvider(
		process.env.REACT_APP_WAREHOUSE_API || ""
	);
	const params = useParams<{ id: string }>();
	const classes = style();
	const questionRefs = useRef<Record<string, HTMLDivElement | null>>({});

	const handleAnswerQuestion = (id: string) => {
		if (!snackbarShow) {
			setSnackbarShow(true);
		}
		scrollToNextQuestion(id);
		setTimeout(() => {
			if (!answeredQuestion.includes(id)) {
				setAnsweredQuestion((prev) => [...prev, id]);
			}
		}, 250);
	};

	const scrollToNextQuestion = (id: string) => {
		if (!campaign || !campaign.feedbackCampaignQuestions) {
			return;
		}
		const questions = campaign.feedbackCampaignQuestions
			.filter((q) => !answeredQuestion.includes(q.id))
			.sort((a, b) => a.order - b.order);
		const currentIndex = questions.findIndex((q) => q.id === id);
		const next = questions[currentIndex + 1];
		if (next) {
			questionRefs.current[next.id]?.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
		}
	};

	useEffect(() => {
		if (snackbarShow) {
			setTimeout(() => {
				setSnackbarShow(false);
			}, 4000);
		}
	}, [snackbarShow]);

	useEffect(() => {
		const handleMessage = () => {
			if (!document.hidden) {
				setStatus("INITIAL");
			}
		};

		document.addEventListener("visibilitychange", handleMessage, false);

		return () => {
			document.removeEventListener("visibilitychange", handleMessage);
		};
	}, []);

	useEffect(() => {
		if (status !== "INITIAL" || !params.id) {
			return;
		}
		setAnsweredQuestion([]);
		setStatus("FETCHING");
		const localDateTime = moment().format("YYYY-MM-DDTHH:mm:ss");
		dataProvider(`b2c/feedbackCampaign/`, {
			method: "POST",
			body: JSON.stringify({
				lockerSellingOrderId: params.id,
				customerDateTime: localDateTime,
				pageTag: "/locker-selling-order",
			}),
		})
			.then((response) => {
				setStatus("FETCHED");
				if (!response) {
					setCampaign(undefined);
					return;
				}
				setCampaign(response);
			})
			.catch((error) => {
				console.log({
					error,
				});
				setStatus("ERROR_FETCHING");
			});
	}, [dataProvider, params.id, status]);

	if (status !== "FETCHED" || !campaign) {
		return null;
	}

	return (
		<div className={classes.feedbackContainer}>
			{campaign.feedbackCampaignQuestions.length !==
				answeredQuestion.length && (
				<Typography variant="caption" color="primary">
					{campaign.message}
				</Typography>
			)}
			<Snackbar
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
				open={snackbarShow}
			>
				<Alert severity="success">Grazie per il tuo feedback</Alert>
			</Snackbar>
			{campaign?.feedbackCampaignQuestions
				.filter((question) => !answeredQuestion.includes(question.id))
				.sort((a, b) => a.order - b.order)
				.map((question) => {
					return (
						<div
							ref={(el) =>
								(questionRefs.current[question.id] = el)
							}
							key={`feedback-question-container-${question.id}`}
						>
							<FeedbackQuestion
								key={`feedback-question-${question.id}`}
								question={question}
								onAnswered={() =>
									handleAnswerQuestion(question.id)
								}
							/>
						</div>
					);
				})}
		</div>
	);
};

const style = makeStyles((theme) => ({
	feedbackContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: "15px",
		marginTop: "20px",
		marginBottom: "20px",
	},
}));
